/* RESPONSIBLE TEAM: team-data-foundations */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class ActionInputParameterMapping extends Fragment {
  @attr('string') declare inputParameterId: string;
  @attr('string') declare templatedValue: string;
}
